import { FullAvailabilityStatus } from 'types';

export type TimeSlot = {
  day: string;
  time: string;
  techId: string;
  availability: SlotAvailability | FullAvailabilityStatus;
  isSurrounding: boolean;
  isSecondaryArea: boolean;
};

export enum SlotAvailability {
  Available = 'Available',
  Confirmation = 'Confirmation',
}

export enum AddressType {
  Physical = 'physical',
  Postal = 'postal',
}

export enum ServiceType {
  OnSite = '1',
  Remote = '2',
  GeekCover = '3',
}

export enum AvailabilityType {
  OnSite = 'onSite',
  Remote = 'remote',
}

export enum ServiceAreaType {
  Primary = 'P',
  Secondary = 'S',
}

export enum JobServiceType {
  Normal = 'N',
  GeekCover = 'GC',
  WarrantyAssessment = 'WA',
  CompanyWarranty = 'C',
  TechnicianWarranty = 'T',
  ContinuationService = 'CS',
  BusinessOpportunities = 'BO',
  Promotions = 'P',
}

export enum JobServiceTypeLabel {
  N = 'Normal',
  GC = 'Geek Cover',
  WA = 'Warranty Assessment',
  C = 'Company Warranty',
  T = 'Technician Warranty',
  CS = 'Continuation Service',
  BO = 'Business Opportunity',
  P = 'Promotions',
}

export enum AccountType {
  Personal = 'P',
  Company = 'C',
}

export enum PricingCategory {
  Home = 'H',
  Business = 'B',
}

export enum PricingCategoryLabel {
  H = 'Home',
  B = 'Business',
}

export enum CustomerNotes {
  StandardNote = 0,
  CourtesyCall = 1,
  ManagementNote = 2,
  IncidentReport = 3,
  PerformanceIssue = 4,
  TechLateOrReschedule = 5,
  Confidential = 6,
  CSSIncident = 7,
  OWIncident = 8,
  BlacklistTechnician = 9,
}

export enum TaskTypes {
  Tickets = 1,
  TicketBusinessSupport = 2,
  Callbacks = 6,
}

export enum CallbackSource {
  OWSale = 'O',
  G2UWebsite = 'W',
}

export enum DiscountType {
  Dollar = 'Dollar Amount',
  Percent = 'Percentage',
  Time = 'Hours',
}

export enum PaymentMethod {
  CreditCard = 'V',
  Cash = 'C',
  Prepaid = 'P',
  WarrantyAssessment = 'WA',
  GeekCover = 'GC',
  Invoice = 'I',
  Square = 'S',
  OW30DBA = 'W',
}

// This is a really bad structure coming back from the backend, not much we
// can do about it but have done my best to comment what the keys actually mean
export type Product = {
  ID: number;
  name: string;
  description: string;
  status: 'active'; // or what?
  tax_rate: string; // number?
  tax_applied: string; // number?
  sub_total: string; // number?
  total: string; // number?
  created_at: string; // yyyy-MM-ddThh:mm:ss.000000Z
  updated_at: string; // yyyy-MM-ddThh:mm:ss.000000Z
  duration?: string; // minutes?
  service_selection?: string[]; // parent IDs?
  service_selection_child?: string[]; // wtf?
  customer_type?: PricingCategory;
  service_type?: string; // wtf? ["1", "2"]
  same_day_service?: string; // product ID?
  weekend_service?: string; // product ID?
  public_holiday_service?: string; // product ID?
  additional_service?: string; // product ID?
  standard_product?: string; // wtf? "1"
  can_technician_add?: string; // boolean?
  restrict_display_in_booking?: string; // boolean?
  same_day_service_product?: string; // boolean?
  remote_labour_rates: string; // number?
  labour_rates?: string; // number?
  labour_qty?: string;
};

// NOTE: Not a ServiceProduct, this is some weird hybrid structure
export type JobProduct = Product & {
  quantity: string; // wtf?
  completion_date: string; // yyyy-MM-dd HH:mm:ss
  service_product_ID: number; // wtf?
};

export type CustomerProduct = {
  ID: number;
  customer_ID: number;
  product_ID: number;
  status: PrepaidProductStatus;
  service_ID: number;
  product_name: string;
  total: string; // '0.0000'
  purchase_date: string; // '06/12/2021 10:36';
};

export enum PrepaidProductStatus {
  New = 'new',
  Applied = 'applied',
  Cancelled = 'cancelled',
  Refunded = 'returned',
}

export enum PrepaidProductStatusLabels {
  new = 'New',
  applied = 'Applied',
  cancelled = 'Cancelled',
  returned = 'Refunded',
}
